export default "__VITE_ASSET__Lf9C6vTW__"